module.exports = __webpack_public_path__ + "static/media/productIntroForm3.4fcfa9ae.jpg";